import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, map, take } from 'rxjs';

import { authFeature } from '../auth/auth.feature';
import { profileFeature } from '../profile/profile.feature';
import { isExpired } from '../models/role.model';

export const notExpiredGuard: CanActivateFn = (): any => {
  const store = inject(Store);
  const router = inject(Router);

  const uid$ = store.select(authFeature.selectUid);
  const status$ = store.select(profileFeature.selectStatus);
  const profile$ = store.select(profileFeature.selectProfile);

  return combineLatest([uid$, status$, profile$]).pipe(
    take(1),
    map(([uid, status, profile]): boolean | UrlTree => {
      if (!uid) return router.parseUrl('/login');

      // Wenn Profil-Load fehlgeschlagen ist, blocken
      if (status === 'error') return router.parseUrl('/login');

      // Profil noch nicht geladen -> nicht vorzeitig blocken (featureGuard prüft später hart)
      if (status !== 'ready' || !profile) return true;

      if (profile.disabled) return router.parseUrl('/login');
      if (isExpired(profile.expiresAt)) return router.parseUrl('/login');

      return true;
    })
  );
};
